import React, { useState, useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import usePermissions from 'hooks/usePermissions';
import { routes } from 'constants/config';
import { TabbedView, TabList, Tab } from 'components/shared/TabbedView';

import ElementLibrary from './ElementLibrary';
import TemplateLibrary from './TemplateLibrary';

const Library = props => {
  const [tabIndex, setTabIndex] = useState(0);
  const { isPermitted: canManageContentLibrary } = usePermissions({
    type: 'content_library',
    action: 'manage',
  });

  const { isPermitted: canManageTemplateLibrary } = usePermissions({
    type: 'template_library',
    action: 'manage',
  });

  const showTabbedView = canManageContentLibrary && canManageTemplateLibrary;

  const selectTab = tab => {
    props.history.push(
      tab === 0
        ? routes.CONTENT.LIBRARY_ELEMENTS
        : routes.CONTENT.LIBRARY_TEMPLATES,
    );
    setTabIndex(tab);
  };

  useEffect(() => {
    if (props.location.pathname === routes.CONTENT.LIBRARY_ELEMENTS) {
      setTabIndex(0);
    } else {
      setTabIndex(1);
    }
  }, [props.location.pathname]);

  return (
    <div className="ContentLibrary ff-ss mt-24">
      <a className="ContentLibrary-backLink link" href={routes.CONTENT.INDEX}>
        {showTabbedView ? (
          <>
            <ArrowLeft size={12} className="mr-8" />
            {t('contents.library.tabbed_back_link')}
          </>
        ) : (
          t('contents.library.back_link')
        )}
      </a>
      <h1 className="ff-ss fs-36 mt-16">{t('contents.library.title')}</h1>
      {showTabbedView && (
        <TabbedView onSelect={selectTab} selectedIndex={tabIndex}>
          <TabList>
            <Tab>{t('contents.library.element_tab_name')}</Tab>
            <Tab>{t('contents.library.template_tab_name')}</Tab>
          </TabList>
        </TabbedView>
      )}

      <Switch>
        {canManageContentLibrary && (
          <Route
            path={routes.CONTENT.LIBRARY_ELEMENTS}
            exact
            component={ElementLibrary}
          />
        )}
        {canManageTemplateLibrary && (
          <Route
            path={routes.CONTENT.LIBRARY_TEMPLATES}
            exact
            component={TemplateLibrary}
          />
        )}
        {/* Redirect any tab not found to default /elements if user can manage the content library */}
        {canManageContentLibrary && (
          <Redirect to={routes.CONTENT.LIBRARY_ELEMENTS} />
        )}
        {/* Redirect any tab not found to default /templates if user can manage the template library but NOT the content library */}
        {canManageTemplateLibrary && (
          <Redirect to={routes.CONTENT.LIBRARY_TEMPLATES} />
        )}
      </Switch>
    </div>
  );
};

export default Library;
